import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Navbar, Nav, NavItem} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import Icon from '../../core/components/Icon'
import UserNavItem from '../../user/components/UserNavItem'
import config from '../../config'
import logo from '../resources/img/logo.png'

class AppNavBar extends Component {
    static propTypes = {
    }

    render() {
        const {location, authenticated, _links} = this.props

        return (
            <Navbar
                bsStyle='jumbo'
                staticTop>
                <Navbar.Header>
                    <Navbar.Brand>
                        <a href='/'>
                            <img src={config.resource.logo && config.resource.logo.url || logo} />
                        </a>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight>
                        <UserNavItem />
                    </Nav>
                    <Nav>
                        {_links.find(linkFinder('tickets')) && (
                            <NavItem active={location.pathname.startsWith('/tickets') || location.pathname.startsWith('/claims')} href={'/tickets'}>
                                <Icon icon='ticket' size='lg' />
                                tickets
                            </NavItem>
                        )}
                        {_links.find(linkFinder('patrimonies')) && (
                            <NavItem active={location.pathname.startsWith('/patrimonies')}  href={'/patrimonies'}>
                                <Icon icon='patrimony' size='lg' />
                                patrimoine
                            </NavItem>
                        )}
                        {_links.find(linkFinder('providercontacts')) && (
                            <NavItem active={location.pathname.startsWith('/providers') || location.pathname.startsWith('/providercontacts')} href={'/providercontacts'}>
                                <Icon icon='provider' size='lg' />
                                fournisseurs
                            </NavItem>
                        )}
                        {_links.find(linkFinder('clientcompanies')) && (
                            <NavItem active={location.pathname.startsWith('/companies')} href={'/companies'}>
                                <Icon icon='customer' size='lg' />
                                clients
                            </NavItem>
                        )}
                        {authenticated.company && (
                            <NavItem active={location.pathname.startsWith('/organisations')} href={'/organisations'}>
                                <Icon icon='organisation' size='lg' />
                                organisation
                            </NavItem>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        )
    }
}

AppNavBar = connect((state) => ({
    location: state.router.location,
    authenticated: state.user.authenticated,
    _links: state.app._links
}))(AppNavBar)

export default AppNavBar


// WEBPACK FOOTER //
// ./lib/app/components/AppNavBar.js